/**
 * Nylas
 */
window.Nylas = {
    /**
     * Display error sync
     */
    connectError: function()
    {
        MyWindow.alert(Loc.g('Pour envoyer des emails depuis Sellsy, vous devez configurer un compte email à votre compte Sellsy pour cela vous pouvez vous rendre dans la rubrique Réglages > Compte email.'), {type:'error'});
    }
};